import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { usePortalAuthentication } from "../../services/authorizationService";

const EulaAction = () => {
  const { userToken, SetSharedObject } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const navigate = useNavigate();
  const [agreeBox, SetAgreeBox] = useState(false); //
  const [agreeBoxMsg, SetAgreeBoxMsg] = useState(false);
  const [errFlag, setErrFlag] = useState(false);
  const [processingAgree, setProcessingAgree] = useState(false);
  const [processingDecline, setProcessingDecline] = useState(false);
  const { logout } = usePortalAuthentication();

  useEffect(() => {
    SetAgreeBoxMsg(false);
  }, []);

  const submitEULA = async (flag) => {
    if (processingAgree || processingDecline) return;
    SetAgreeBoxMsg(false);
    if (flag === "decline") {
      await logout();
      setProcessingDecline(false);
      return;
    }
    if (!agreeBox) {
      SetAgreeBoxMsg(true);
      return;
    }

    setProcessingAgree(true);
    setErrFlag(false);

    try {
    const call = "/admin/EULAFunction";
    const res = await CallAPI(call, false, "post", userToken);

    SetSharedObject("ResponseCode", res.code);

    if (res && res.status === "SUCCESS") {
      if (res.data.page === "ChangePassword") {
        navigate("/password-change-preRegistration");
      } else if (res.data.page === "dashboard") {
        navigate("/dashboard");
      } else if (res.data.page === "SSO") {
        navigate("/experian-sso");
      }
    } else if (res?.status === "SERVERERROR") {
      setErrFlag(true);
    } else {

      setErrFlag(true);
    }
  } catch (error) {
    console.error("EULA submission failed:", error);
    setErrFlag(true);
  } finally {

    setProcessingAgree(false);
    setProcessingDecline(false);
  }
  };
  return (
    <>
      { /*Having the input field inside the label was done on purpose due to customization*/}
      <label htmlFor="eula-agree" className="license-container">
        <input
          type="checkbox"
          className="form-control spacer-margin5"
          id="eula-agree"
          checked={agreeBox}
          onChange={(el) => {
            SetAgreeBox(el.target.checked);
            if (el.target.checked) SetAgreeBoxMsg(false);
          }}
          aria-describedby="eula-agree-desc"
        />
        <span id="eula-agree-desc">TO CONFIRM USE THE PRODUCTS UNDER THE EXISTING AGREEMENT AND THESE STANDARD TERMS, CLICK "I AGREE" BELOW.</span>
      </label>
      {errFlag ? (
        <div className="ml-2">
          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" id="eula-submit-error">
            System encounted an error. Please try again. If the problem
            persists, please contact your administrator.
          </div>
        </div>
      ) : null}
      {agreeBoxMsg ? (
        <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" id="eula-agree-error">
          Don't forget to check the box if you agree.
        </div>
      ) : null}

      <div className="eula-button-container">
        <div className="button-accept">
          <button
            type="button"
            className="btn btn-success"
            value="I Agree"
            onClick={(e) => submitEULA("submit")}
            aria-describedby="eula-submit-error"
            disabled={processingAgree || processingDecline}
          >
            {processingAgree ? "Authorizing..." : "I Agree"}
          </button>
        </div>

        <div className="button-decline">
          <button
            type="button"
            className="btn btn-outline-secondary"
            value="I Decline"
            onClick={(e) => submitEULA("decline")}
            disabled={processingAgree || processingDecline}
          >
             {processingDecline ? "Signing Out..." : "I Decline"}
          </button>
        </div>
      </div>
    </>
  );
};

export default EulaAction;
